import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { sciLanguageSelector } from 'src/components/shared/SciPage/SciPage.selector';
import { getLangCode } from 'src/utils/string';
import { SCIApi, selfCheckInRoute } from '../apis';
import { VideoContent } from '../types/SciContent';

export const useGetVideoContentKey = 'useGetVideoContentKey';
export const getVideoContentRoute = `${selfCheckInRoute}/contents/videos`;

const getContent = async (key: string, language: string) => {
    const apiCalls = SCIApi.getInstance();
    apiCalls.configureLanguage(language);
    const result: AxiosResponse<VideoContent[]> = await apiCalls.get<
        VideoContent[]
    >(getVideoContentRoute, {
        key,
    });

    return result?.data ?? result;
};

export const useSciVideoContent = (key: string) => {
    const language = getLangCode(useSelector(sciLanguageSelector));
    const { isLoading, isError, data, refetch } = useQuery({
        queryKey: [useGetVideoContentKey, key],
        queryFn: () => getContent(key, language),
    });

    useEffect(() => {
        refetch();
    }, [language, refetch]);

    return {
        isLoading,
        isError,
        data,
    };
};
